$(function() {

	$.nette.ext('verificationInput', {
		init: function() {
			this.init();
		},
		success: function() {
			this.init();
		}
	}, {
		init: function() {

			const codeInputs = document.querySelectorAll('.verification-input');

			// Automatically move focus to the next input field upon entering a value
			codeInputs.forEach((input, index) => {
				input.addEventListener('input', () => {
					if (input.value.length === 1 && index < codeInputs.length - 1) {
						codeInputs[index + 1].focus();
					}
				});
			});

			// Handle paste event
			codeInputs.forEach((input, index) => {
				input.addEventListener('paste', (event) => {
					event.preventDefault();
					const pastedData = event.clipboardData.getData('text/plain');
					const pastedCode = pastedData.slice(0, 6);
					const codeArray = pastedCode.split('');

					codeInputs.forEach((input, i) => {
						input.value = codeArray[i] || '';
					});
				});
			});

			// Automatically move focus to the previous input field upon deletion
			codeInputs.forEach((input, index) => {
				input.addEventListener('keydown', (event) => {
					if (event.key === 'Backspace' && input.value === '' && index > 0) {
						codeInputs[index - 1].focus();
					}
				});
			});

		}
	});

});
